export default "__VITE_ASSET__BoU0B4fl__"